import { render, staticRenderFns } from "./empty_state.vue?vue&type=template&id=4f0c031b&"
import script from "./empty_state.vue?vue&type=script&lang=js&"
export * from "./empty_state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports